import { ListItem, UnorderedList } from "@chakra-ui/react";
import { GiServerRack } from "@onemind-services-llc/react-icons-ng/gi";
import { IoServerOutline } from "@onemind-services-llc/react-icons-ng/io5";
import { AiOutlineCloudServer } from "@onemind-services-llc/react-icons-ng/ai";
import ManageMaintainHardware from "public/laas/manage-maintain-hardware.webp";
import BuildTopology from "public/laas/build-topology.webp";
import TechnologyAgnostic from "public/laas/technology-agnostic.webp";
import VendorAgnostic from "public/laas/vendor-agnostic.webp";
import SecuredAccess from "public/laas/secured-acess-with-MFA.webp";
import Sla from "public/laas/support-sla.webp";
import TechnicalSupport from "public/laas/technical-support.webp";
import SecuredSetup from "public/laas/secured-setup.webp";

export const HERO_DESCRIPTION = [
  "Unlock advanced network testing without the infrastructure burden. CloudMyLab's IT Lab as a Service delivers state-of-the-art virtual environments on demand. Accelerate innovation, reduce risks, and cut costs – all while keeping pace with rapidly evolving technology.",
  "CloudMyLab takes care of all that so you can focus on your business.",
];

export const FEATURES_LIST = [
  {
    title: "Effortless Infrastructure Management",
    content: [
      "CloudMyLab handles all hardware, software, and licensing needs, including maintenance and monitoring. Remote power and console access ensure swift issue resolution, freeing your team to focus on core tasks.",
    ],
    image: ManageMaintainHardware,
  },
  {
    title: "Build/Change Any Topology Anytime",
    content: [
      "Adapt your testing environment on-the-fly with our near-perfect automation for equipment management. Design, document, and modify complex network topologies at will, accelerating your development cycles.",
    ],
    image: BuildTopology,
  },
  {
    title: "Technology Agnostic",
    content: [
      "We can support any technology that you need. In most cases, we will find a tech internally, if not we will figure out a way to get your tech installed through our partner network.",
    ],
    image: TechnologyAgnostic,
  },
  {
    title: "Vendor Agnostic",
    content: [
      "CloudMyLab partners with any vendors that our customers require. It is our job to get you what you need legitimately.",
    ],
    image: VendorAgnostic,
  },
  {
    title: "Secured Access using Cisco AnyConnect with DUO MFA",
    content: [
      "Protect your intellectual property with our robust security measures, including Cisco AnyConnect VPN and DUO Multi-Factor Authentication, providing peace of mind for sensitive testing environments.",
    ],
    image: SecuredAccess,
  },
  {
    title: "Support and SLA",
    content: [""],
    image: Sla,
    element: (
      <UnorderedList color={"gray.500"}>
        <ListItem>24/7/362 Support</ListItem>
        <ListItem>99.9% SLA</ListItem>
      </UnorderedList>
    ),
  },
  {
    title: "Dedicated Account Manager and Technical Support",
    content: [
      "You will always be assigned dedicated account Manager and Technical Staff with access to all your documentation on the cloud.",
    ],
    image: TechnicalSupport,
  },
  {
    title: "Secured Setup and Dedicated Racks",
    content: [
      "We offer secure physical racks with authorized access and log reviews. Our dedicated 1G symmetric bandwidth, upgradable to 10 or 40G, includes content filtering and endpoint security on jump boxes. SIEM event log analysis is provided for all equipment.",
    ],
    image: SecuredSetup,
  },
];

export const LAB_AS_SERVICE_TECH_STACK = [
  {
    heading: "Development Network Sandbox",
    content:
      "Our Development Network Sandbox offers a flexible environment for developers and network engineers to design, test, and refine network configurations without the constraints of physical hardware.",
    icon: GiServerRack,
  },
  {
    heading: "Network Automation Lab",
    content:
      "The Network Automation Lab provides a dedicated space for automating and testing network configurations.",
    icon: IoServerOutline,
  },
  {
    heading: "Home Network Lab Enthusiasts",
    content:
      "Designed for hobbyists and individuals, our Network Labs allows you to experiment with network configurations from the comfort of your home. Enjoy affordable plans, easy setup, and powerful virtual networking tools.",
    icon: AiOutlineCloudServer,
  },
];

export const LAB_AS_SERVICE_FAQ_LIST = [
  {
    title: "How quickly can I set up and access my IT lab environment?",
    content:
      " With CloudMyLab's Lab as a Service, you can have your custom IT lab environment up and running within hours. Our streamlined process allows for rapid deployment, enabling you to start your testing and development work almost immediately.",
  },
  {
    title: "Can I integrate my existing tools and software into the lab environment?",
    content:
      "Absolutely! Our IT Lab as a Service is designed to be flexible and accommodate your specific needs. We support integration with a wide range of tools and software, ensuring your lab environment mirrors your production setup as closely as possible.",
  },
  {
    title: "How does pricing work for CloudMyLab's IT Lab as a Service?",
    content:
      "Our pricing is flexible and based on your specific needs. We offer various models, including pay-as-you-go options and discounted rates for longer-term commitments. This allows you to optimize costs based on your usage patterns and project requirements. Contact us for a customized quote tailored to your needs.",
  },
];

export const LabAsAService_Reason = [
  "  With Lab as a Service (LaaS), you get on-demand access to virtual IT laboratory environments in the cloud. You can set up, use, and manage complex network topologies and multi-vendor environments without investing in physical hardware.",
  " LaaS offers you flexibility, scalability, and cost-effectiveness for your testing, development, and training needs, all while we fully manage the service for you.",
];

export const whyLabAsAService = [
  {
    title: "How does Lab as a Service benefit organizations?",
    desc: "With LaaS, you'll enjoy several benefits for your organization. You'll see significant cost savings as you eliminate the need for hefty upfront investments in lab equipment and infrastructure. You can easily scale your lab resources up or down based on your current needs, giving you unparalleled flexibility. Plus, you'll enhance collaboration among your team members by providing them with remote access to a common set of tools and environments, no matter where they're located. This means your team can work efficiently and cohesively, regardless of geographical barriers.",
  },
  {
    title: "What industries can benefit from Lab as a Service?",
    desc: "You'll find that LaaS can benefit your organization, especially if you're in IT, telecommunications, software development, education, or research. Whether you need to conduct software testing, simulate complex networks, run training sessions, or perform academic research, LaaS offers you a flexible and efficient solution. You can handle a wide variety of lab-related activities without the hassle of managing physical infrastructure. This means you'll have more time to focus on innovation and results, rather than worrying about lab setup and maintenance.",
  },
  {
    title: "How does Lab as a Service integrate with existing IT infrastructure?",
    desc: "You can seamlessly integrate LaaS with your existing IT infrastructure, enhancing your organization's capabilities with this complementary resource. Depending on your specific needs and the provider you choose, you'll find various integration options available to you. Typically, you'll have access to APIs and other tools that allow you to connect LaaS with your existing systems and workflows. This integration enables you to efficiently manage your lab environments alongside your other IT resources, streamlining your operations and boosting your team's productivity. You'll appreciate how LaaS fits smoothly into your current IT ecosystem, providing you with a powerful, flexible testing and development environment without disrupting your established processes.",
  },
];
